import { render, staticRenderFns } from "./ListVarieties.vue?vue&type=template&id=a8ee34c8&scoped=true"
import script from "./ListVarieties.vue?vue&type=script&lang=js"
export * from "./ListVarieties.vue?vue&type=script&lang=js"
import style0 from "./ListVarieties.vue?vue&type=style&index=0&id=a8ee34c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ee34c8",
  null
  
)

export default component.exports